class CustomGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this); // stop observing once triggered
        var gallery = $(this).attr("section_id");
        var swiper1 = new Swiper(".gallery-slider-1-" + gallery, {
          slidesPerView: "auto",
          spaceBetween: 22,
          freeMode: true,
          centeredSlides: true,
          speed: 9000,
          autoplay: {
            delay: 1,
          },
          loop: true,
          // allowTouchMove: false,
          // disableOnInteraction: false
        });
        var swiper2 = new Swiper(".gallery-slider-2-" + gallery, {
          slidesPerView: "auto",
          spaceBetween: 22,
          freeMode: true,
          loop: true,
          centeredSlides: true,
          speed: 9000,
          autoplay: {
            delay: 1,
            reverseDirection: true,
          },
          // allowTouchMove: false,
          // disableOnInteraction: false
        });
      },
      {
        rootMargin: "0px 0px 400px 0px",
      }
    );

    observer.observe(this);
  }
}

customElements.define("custom-gallery", CustomGallery);

class ProductSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this); // stop observing once triggered
        $(this).css({ opacity: "1" });

        new Swiper(".product-slider", {
          slidesPerView: 1,
          spaceBetween: 16,
          navigation: {
            nextEl: ".swiper-button-next--" + sectionId,
            prevEl: ".swiper-button-prev--" + sectionId,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
            1250: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
          },
          on: {
            init: () => {
              updateSwiperParentState();
            },
            slideChange: () => {
              updateSwiperParentState();
            },
          },
        });
      },
      {
        rootMargin: "0px 0px 400px 0px",
      }
    );

    observer.observe(this);
  }
}

customElements.define("product-slider", ProductSlider);

class RelatedSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this); // stop observing once triggered
        $(this).css({ opacity: "1" });

        new Swiper(".related-slider", {
          slidesPerView: 1,
          spaceBetween: 16,
          navigation: {
            nextEl: ".swiper-button-next--" + sectionId,
            prevEl: ".swiper-button-prev--" + sectionId,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
            1250: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
          },
          on: {
            init: () => {
              updateSwiperParentState();
            },
            slideChange: () => {
              updateSwiperParentState();
            },
          },
        });
      },
      {
        rootMargin: "0px 0px 400px 0px",
      }
    );

    observer.observe(this);
  }
}
customElements.define("related-slider", RelatedSlider);

class BrandSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.sectionId = this.getAttribute("data-sectionid");
    this.resizeHandler = this.onResize.bind(this);
  }

  connectedCallback() {
    this.initSwiperIfNeeded();
    window.addEventListener("resize", this.resizeHandler);
  }

  disconnectedCallback() {
    this.destroySwiper();
    window.removeEventListener("resize", this.resizeHandler);
  }

  onResize() {
    // Always destroy the existing instance
    this.destroySwiper();

    // Reinitialize only if screen is large enough
    if (window.innerWidth >= 990) {
      this.initSwiper();
    }
  }

  initSwiperIfNeeded() {
    if (window.innerWidth >= 990) {
      this.initSwiper();
    }
  }

  initSwiper() {
    $(this).css({ opacity: "1" });

    this.swiperInstance = new Swiper(".brand-slider", {
      slidesPerView: 1,
      spaceBetween: 24,
      grid: {
        rows: 2,
      },
      navigation: {
        nextEl: ".swiper-button-next--" + this.sectionId,
        prevEl: ".swiper-button-prev--" + this.sectionId,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        560: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1250: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
      on: {
        init: () => {
          updateSwiperParentState();
        },
        slideChange: () => {
          updateSwiperParentState();
        },
      },
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

customElements.define("brand-slider", BrandSlider);

class FaqSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({ opacity: "1" });

      const sectionId = this.getAttribute("data-sectionid");

      $(".faq-questions-" + sectionId).click(function (e) {
        e.preventDefault();
        let $this = $(this);
        if ($this.next().hasClass("show")) {
          $this.next().removeClass("show");
          $this.next().slideUp(350);
          $this.parent().removeClass("active");
          $this
            .find(".fa-chevron-arrows .fa-chevron-down")
            .css({ display: "flex" });
          $this
            .find(".fa-chevron-arrows .fa-chevron-up")
            .css({ display: "none" });
        } else {
          $(".faq-accordion-wrapper .faq-answers")
            .removeClass("show")
            .slideUp(350);
          $(".faq-accordion-wrapper").removeClass("active");
          $(".faq-accordion-wrapper .fa-chevron-arrows .fa-chevron-down").css({
            display: "flex",
          });
          $(".faq-accordion-wrapper .fa-chevron-arrows .fa-chevron-up").css({
            display: "none",
          });

          $this.next().toggleClass("show").slideToggle(350);
          $this.parent().toggleClass("active");
          $this
            .find(".fa-chevron-arrows .fa-chevron-down")
            .css({ display: "none" });
          $this
            .find(".fa-chevron-arrows .fa-chevron-up")
            .css({ display: "flex" });
        }
      });

      // Trigger click on the first question to open it by default
      const $firstQuestion = $(".faq-questions-" + sectionId).first();
      if ($firstQuestion.length) {
        $firstQuestion.trigger("click");
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("faq-section", FaqSection);

class CustomReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const self = this;
    const sectionId = self.getAttribute("data-sectionid");

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(self);
      $(self).css({ opacity: "1" });

      let swiper;
      var totalslide = $(this).find(".swiper-slide").length;
      
      if (window.innerWidth >= 769) {
        swiper = new Swiper(".review-slider--" + sectionId, {
          slidesPerView: 1,
          spaceBetween: 16,
          centeredSlides: true,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next--" + sectionId,
            prevEl: ".swiper-button-prev--" + sectionId,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 1,
              spaceBetween: 16,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
          on: {
            slideChangeTransitionStart: () => setSlideFadeEffect(swiper),
            init: () => setSlideFadeEffect(swiper),
          },
        });

        function setSlideFadeEffect(swiperInstance) {
          swiperInstance.slides.forEach((slide) => {
            const isActive = slide.classList.contains("swiper-slide-active");
            slide.style.opacity = isActive ? "1" : "0.4";
            slide.style.transform = isActive ? "scale(1)" : "scale(0.95)";
            slide.style.transition = "opacity 0.3s ease, transform 0.3s ease";
          });
        }
      } else {
        swiper = new Swiper(".review-slider--" + sectionId, {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          centeredSlidesBounds: true,
          loopAdditionalSlides: 0,
          loop: true,
          watchSlidesProgress: true,
          loopedSlides: totalslide,
          slideToClickedSlide: true,
          navigation: {
            nextEl: ".swiper-button-next--" + sectionId,
            prevEl: ".swiper-button-prev--" + sectionId,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
          on: {
            slideChange: function () {
              // Sometimes you might need to force update
              this.pagination.update();
            },
          },
        });
      }
    };

    new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 400px 0px",
    }).observe(self);
  }
}

customElements.define("custom-reviews", CustomReviews);


class AnniversaryReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const self = this;
    const sectionId = self.getAttribute("data-sectionid");

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(self);
      $(self).css({ opacity: "1" });

      let swiper;
      var totalslide = $(this).find(".swiper-slide").length;
      var desktop = $(this).data('desktop');
      var mobile = $(this).data('mobile');
      if (window.innerWidth >= 769) {
        swiper = new Swiper(".review-slider--" + sectionId, {
          slidesPerView: mobile,
          spaceBetween: 12,
          centeredSlides: false,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next--" + sectionId,
            prevEl: ".swiper-button-prev--" + sectionId,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: mobile,
              spaceBetween: 12,
              centeredSlides: false,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            1200: {
              slidesPerView: desktop,
              spaceBetween: 24,
              centeredSlides: true,
            },
          },
          on: {
            slideChangeTransitionStart: () => setSlideFadeEffect(swiper),
            init: () => setSlideFadeEffect(swiper),
          },
        });

        function setSlideFadeEffect(swiperInstance) {
          swiperInstance.slides.forEach((slide) => {
            const isActive = slide.classList.contains("swiper-slide-active");
            slide.style.opacity = isActive ? "1" : "0.4";
            slide.style.transform = isActive ? "scale(1)" : "scale(0.95)";
            slide.style.transition = "opacity 0.3s ease, transform 0.3s ease";
          });
        }
      } else {
        swiper = new Swiper(".review-slider--" + sectionId, {
          slidesPerView: mobile,
          spaceBetween: 12,
          centeredSlidesBounds: true,
          loopAdditionalSlides: 0,
          loop: true,
          watchSlidesProgress: true,
          loopedSlides: totalslide,
          slideToClickedSlide: true,
          navigation: {
            nextEl: ".swiper-button-next--" + sectionId,
            prevEl: ".swiper-button-prev--" + sectionId,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: mobile,
              spaceBetween: 12,
              centeredSlides: false,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            1200: {
              slidesPerView: desktop,
              spaceBetween: 24,
              centeredSlides: true,
            },
          },
          on: {
            slideChange: function () {
              // Sometimes you might need to force update
              this.pagination.update();
            },
          },
        });
      }
    };

    new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 400px 0px",
    }).observe(self);
  }
}

customElements.define("custom-anniversary-reviews", AnniversaryReviews);

// class ComplementarySliderDrawer extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     const sectionId = this.getAttribute("data-sectionid");
//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (!entries[0].isIntersecting) return;

//         observer.unobserve(this); // stop observing once triggered

//         new Swiper(".complementary-products-slider-drawer", {
//           slidesPerView: 3.5,
//           spaceBetween: 12,
//         });
//       },
//       {
//         rootMargin: "0px 0px 400px 0px",
//       }
//     );
//     observer.observe(this);
//   }
// }

// customElements.define("complementary-slider-drawer", ComplementarySliderDrawer);

class ProductGrid extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.sectionId = this.getAttribute("data-sectionid");
    this.resizeHandler = this.onResize.bind(this);
  }

  connectedCallback() {
    this.initSwiperIfNeeded();

    // Optional: Fade in when visible
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        $(this).css({ opacity: "1" });
      },
      {
        rootMargin: "0px 0px 400px 0px",
      }
    );
    observer.observe(this);

    window.addEventListener("resize", this.resizeHandler);
  }

  disconnectedCallback() {
    this.destroySwiper();
    window.removeEventListener("resize", this.resizeHandler);
  }

  onResize() {
    this.destroySwiper();
    if (window.innerWidth <= 1024) {
      this.initSwiper();
    }
  }

  initSwiperIfNeeded() {
    if (window.innerWidth <= 1024) {
      this.initSwiper();
    }
  }

  initSwiper() {
    this.swiperInstance = new Swiper(".product-grid", {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-button-next--" + this.sectionId,
        prevEl: ".swiper-button-prev--" + this.sectionId,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        990: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
      },
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

customElements.define("product-grid", ProductGrid);

 
class BrandSliderNew extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
 
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(this).css({ opacity: '1' });

      const sectionId = this.getAttribute('data-sectionid');

      new Swiper('.brand-slider-' + sectionId, {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 20,
        grid: {
          rows: 1,
          fill: 'row',
        },
        navigation: {
          nextEl: '.swiper-button-next--' + sectionId,
          prevEl: '.swiper-button-prev--' + sectionId,
        },
        breakpoints: {
          390: {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 20,
            grid: {
              rows: 1,
              fill: 'row',
            },
          },
          769: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 24,
            grid: {
              rows: 2,
              fill: 'row',
            },
          },
          1250: {
            slidesPerView: "4",
            slidesPerGroup: 1,
            spaceBetween: 24,
            grid: {
              rows: 2,
              fill: 'row',
            },
          },
        },
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 300px 0px',
    });

    observer.observe(this);
  }
}

customElements.define('brand-slider-new', BrandSliderNew);

class CustomExtraProductInfo extends HTMLElement {
  constructor() {
    super();

    this.logoSwiper = null;
    this.videoThumbSwiper = null;
    this.videoPopupSwiper = null;
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(this).css({ opacity: "1" });
      this.initProductVideoPopup();
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }

  disconnectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");

    this.logoSwiper?.destroy?.(true, true);
    this.videoThumbSwiper?.destroy?.(true, true);
    this.videoPopupSwiper?.destroy?.(true, true);

    $(this).off(`click.videoPopup-${sectionId}`);
    $(`.video-close-${sectionId}`).off(`click.videoPopupClose-${sectionId}`);
    $(`.video-navigation-next-${sectionId}, .video-navigation-prev-${sectionId}`).off(`click.videoNav-${sectionId}`);
  }

  initProductVideoPopup() {
    const sectionId = this.getAttribute("data-sectionid");
    if (!sectionId || typeof Swiper === "undefined") return;

    const videoSlider =
      this.querySelector(`.video-slider-${sectionId}`) ||
      document.querySelector(`.video-slider-${sectionId}`);

    const videoPopupSlider = document.querySelector(`.video-slider-popup-${sectionId}`);
    const videoPopupWrapper = document.querySelector(`.video-slider-popup-wrapper-${sectionId}`);
    const videoClose = document.querySelector(`.video-close-${sectionId}`);

    if (!videoSlider || !videoPopupSlider || !videoPopupWrapper) return;

    this.videoThumbSwiper?.destroy?.(true, true);
    this.videoPopupSwiper?.destroy?.(true, true);

    this.videoThumbSwiper = new Swiper(videoSlider, {
      slidesPerView: "auto",
      spaceBetween: 8,
      centeredSlides:false,
      loop:false,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
    });

    $(videoSlider).css("opacity", "1");

    this.videoPopupSwiper = new Swiper(videoPopupSlider, {
      direction: "vertical",
      slidesPerView: 1,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: `.video-navigation-next-${sectionId}`,
        prevEl: `.video-navigation-prev-${sectionId}`,
      },
      thumbs: {
        swiper: this.videoThumbSwiper,
      },
      on: {
        init: () => {
          this.pauseNonActivePopupVideos(sectionId);
        },
        slideChangeTransitionStart: () => {
          this.stopAllPopupVideos(sectionId);
        },
        slideChangeTransitionEnd: () => {
          this.playActivePopupVideo(sectionId);
        },
        slideChange: () => {
          setTimeout(() => {
            this.playActivePopupVideo(sectionId);
          }, 80);
        },
      },
    });

    $(this)
      .off(`click.videoPopup-${sectionId}`)
      .on(`click.videoPopup-${sectionId}`, `.anniversary-video-wrapper`, (event) => {
        const clickedIndex = $(event.currentTarget).closest(".swiper-slide").index();

        $(videoPopupWrapper).addClass("active");

        this.videoPopupSwiper.slideTo(clickedIndex, 0);

        setTimeout(() => {
          this.playActivePopupVideo(sectionId);
        }, 150);
      });

    $(`.video-navigation-next-${sectionId}, .video-navigation-prev-${sectionId}`)
      .off(`click.videoNav-${sectionId}`)
      .on(`click.videoNav-${sectionId}`, () => {
        setTimeout(() => {
          this.playActivePopupVideo(sectionId);
        }, 150);
      });

    $(videoClose)
      .off(`click.videoPopupClose-${sectionId}`)
      .on(`click.videoPopupClose-${sectionId}`, () => {
        $(videoPopupWrapper).removeClass("active");
        this.stopAllPopupVideos(sectionId);
      });
  }

  stopAllPopupVideos(sectionId) {
    $(`.video-slider-popup-${sectionId} video`).each(function () {
      this.pause();
      this.currentTime = 0;
    });
  }

  pauseNonActivePopupVideos(sectionId) {
    $(`.video-slider-popup-${sectionId} .swiper-slide`).each(function () {
      const video = $(this).find("video").get(0);

      if (!video) return;

      if ($(this).hasClass("swiper-slide-active")) {
        return;
      }

      video.pause();
      video.currentTime = 0;
    });
  }

  playActivePopupVideo(sectionId) {
    const popupWrapper = document.querySelector(`.video-slider-popup-wrapper-${sectionId}`);
    if (!popupWrapper || !popupWrapper.classList.contains("active")) return;

    const popupSlider = document.querySelector(`.video-slider-popup-${sectionId}`);
    if (!popupSlider) return;

    const activeSlide = popupSlider.querySelector(".swiper-slide-active");
    if (!activeSlide) return;

    $(`.video-slider-popup-${sectionId} video`).each(function () {
      if (!activeSlide.contains(this)) {
        this.pause();
        this.currentTime = 0;
      }
    });

    const video = activeSlide.querySelector("video");

    if (video) {
      video.muted = false;
      video.currentTime = 0;
      video.play().catch(function (error) {
        console.log("Video play failed:", error);
      });
    }
  }
}

customElements.define("custom-extra-product-info", CustomExtraProductInfo);; 


function wrapVideoTextEmojis() {
  const emojiRegex = /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu;
  
  document.querySelectorAll('.video-text').forEach(function (el) {
    if (el.dataset.emojiWrapped === 'true') return;
    
    // Get text content, don't touch HTML tags
    el.childNodes.forEach(function (node) {
      if (node.nodeType === 3) { // Text node
        const text = node.textContent;
        if (emojiRegex.test(text)) {
          const wrapper = document.createElement('span');
          wrapper.innerHTML = text.replace(emojiRegex, '<span class="emoji-reset">$1</span>');
          node.parentNode.replaceChild(wrapper, node);
        }
      }
    });
    
    el.dataset.emojiWrapped = 'true';
  });
}

// Init
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wrapVideoTextEmojis);
} else {
  wrapVideoTextEmojis();
}
document.addEventListener('shopify:section:load', wrapVideoTextEmojis);
document.addEventListener('shopify:block:select', wrapVideoTextEmojis);

class ComplementarySliderDrawer extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      if (this.__initialized) return;
      this.__initialized = true;

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.initSwiper();
          this.bindAddToCart();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      observer.observe(this);

      if (typeof subscribe !== 'undefined' && subscribe.PUB_SUB_EVENTS) {
        this.cartUpdateUnsubscriber = subscribe(
          subscribe.PUB_SUB_EVENTS.cartUpdate,
          this.handleCartUpdate.bind(this)
        );
      }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    initSwiper() {
      const slider = this.querySelector('.complementary-products-slider-drawer');
      const nextBtn = this.querySelector('.swiper-drawer-next');
      const prevBtn = this.querySelector('.swiper-drawer-prev');
      if (!slider) return;

      this.swiper = new Swiper(slider, {
        slidesPerView: 3.5,
        spaceBetween: 12,
        watchSlidesProgress: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
          0: { slidesPerView: 3.3, spaceBetween: 12 },
          600: { slidesPerView: 3.3, spaceBetween: 12 },
          768: { slidesPerView: 3.3, spaceBetween: 12 },
          1024: { slidesPerView: 3.5, spaceBetween: 12 },
        },
      });
    }

    bindAddToCart() {
      this.querySelectorAll('.complementary-product-card').forEach((card) => {
        const btn = card.querySelector('[data-add-to-cart]');
        if (!btn || btn.dataset.bound === 'true') return;
        btn.dataset.bound = 'true';

        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();

          // ✅ Variant ID from BUTTON's own data attribute (matches card's displayed variant)
          const variantId = btn.dataset.variantId;
          if (!variantId) {
            console.error('No variant ID found on button');
            return;
          }

          btn.classList.add('loading');
          btn.setAttribute('disabled', 'disabled');

          try {
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            const config = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                items: [{ id: parseInt(variantId, 10), quantity: 1 }],
                sections: cart ? cart.getSectionsToRender().map((s) => s.id) : [],
                sections_url: window.location.pathname,
              }),
            };

            const res = await fetch(`${routes.cart_add_url}.js`, config);
            const data = await res.json();

            if (data.status) {
              console.error('Add to cart failed:', data.description || data.message);
              btn.classList.remove('loading');
              btn.removeAttribute('disabled');
              return;
            }

            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(data);
            }

            if (typeof publish !== 'undefined' && publish.PUB_SUB_EVENTS) {
              publish(publish.PUB_SUB_EVENTS.cartUpdate, {
                source: 'complementary-drawer',
                cartData: data,
              });
            }
          } catch (err) {
            console.error('Add to cart error:', err);
            btn.classList.remove('loading');
            btn.removeAttribute('disabled');
          }
        });
      });
    }

    handleCartUpdate(event) {
      const sectionId = this.closest('[id^="shopify-section-"]')?.id || '';
      if (!sectionId) return;

      const url = `${window.location.pathname}?section_id=${sectionId.replace('shopify-section-', '')}`;
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newContent = doc.querySelector('complementary-slider-drawer');
          if (!newContent) return;

          this.replaceWith(newContent);
          setTimeout(() => {
            newContent.__initialized = false;
            if (newContent.connectedCallback) newContent.connectedCallback();
          }, 50);
        })
        .catch((err) => console.error('Section refresh failed:', err));
    }
  }

  if (!customElements.get('complementary-slider-drawer')) {
    customElements.define('complementary-slider-drawer', ComplementarySliderDrawer);
  }